import script from "./BasePicklist.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePicklist.vue?vue&type=script&setup=true&lang=js"

import "./BasePicklist.vue?vue&type=style&index=0&id=52d9159f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52d9159f"]])

export default __exports__